<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		
		<div class="mb-2 mt-2 pt-3">
				<template>
					<div style="margin-top:10px">
						<router-link :to="{name:'set_manager_rule'}" >
							<el-button class="mr-2" v-auth="'addRule'" type="primary" size="mini">{{$t('managerList.addRole')}}</el-button>
						</router-link>

						<el-button type="danger" @click="deleteAll" v-auth="'delRule'" size="mini">{{$t('layout.batchDelete')}}</el-button>
						
					</div>
			</template>
		</div>

		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">
				</el-table-column>
				<el-table-column align="center" type="index" :label="$t('managerList.sort')" width="50">
				</el-table-column>
				<el-table-column align="center" prop="name" :label="$t('managerList.roleName')">
				</el-table-column>
				<el-table-column align="center" prop="create_time" :label="$t('layout.createTime')">
				</el-table-column>
				<el-table-column prop="id" align="center" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'addRule'" @click="editItem(scope.row)">{{$t('layout.operation')}}</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'delRule'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
				layout="total, prev, pager, next, sizes, jumper"
				:total="page.total"
				/>
			</div>
		</el-footer>
	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout'],
		mixins: [common],
		data() {
			return {
				//搜索數据
				from: {
					name: '',
				},
				preUrl: "user/ruleList", //列表地址
				delAllUrl: "user/delRuleAll", //批量删除地址
				delUrl: "user/delRule", //删除單条地址
				tableData: [],
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			computedLeft() {
				return this.layout.isCollapse ? "64px" : "200px"; // ✅ 计算 left
			},
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {

		},
		methods: {
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: ''
				}
				this.$refs.buttonSearch[this.tabIndex].closeSuperSearch()
			},
		}
	}
</script>

<style>
</style>